import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { getFilterOptions } from "constants/filters";
export default function useDriverList({
  selectedDriverId,
  setSelectedDriverId,
  setSelectedDriver,
  cityIds,
}) {
  const { t } = useTranslation("common");
  const [filterAreaOpen, setFilterAreaOpen] = React.useState(false);
  const [pinnedFilterIds, setPinnedFilterIds] = React.useState([]);
  const selectedRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const filterOptions = getFilterOptions(t, cityIds);

  const handleClick = (driver) => {
    const id = driver.id;
    if (selectedDriverId === id) {
      setSelectedDriverId(null);
      setSelectedDriver(null);
    } else {
      setSelectedDriverId(id);
      setSelectedDriver(driver);
    }
  };

  const updateFilters = (id) => {
    const filter = filterOptions.find((item) => item.id === id);
    if (filter) {
      setPinnedFilterIds((prevState) => {
        if (prevState.includes(filter.id)) {
          return prevState?.filter((id) => id !== filter.id);
        } else {
          return [...prevState, filter.id];
        }
      });
    }
  };

  const updatePinnedFilters = (id) => {
    const filter = filterOptions.find((item) => item.id === id);
    if (filter) {
      setPinnedFilterIds((prevState) => {
        if (prevState.includes(filter.id)) {
          return prevState?.filter((id) => id !== filter.id);
        } else {
          return [...prevState, filter.id];
        }
      });
    }
  };

  return {
    t,
    filterAreaOpen,
    setFilterAreaOpen,
    pinnedFilterIds,
    setPinnedFilterIds,
    selectedRef,
    isLoading,
    setIsLoading,
    filterOptions,
    handleClick,
    updateFilters,
    updatePinnedFilters,
  };
}
